import { useRoutes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "components/ErrorFallback";
import { LoaderComponent } from "components/Loader";
import routes from "router/router.config";
import { Suspense } from "react";
import { AutofillScrollManager } from "./components/AutofillScrollManager/AutofillScrollManager";

function App() {
  const elements = useRoutes(routes);
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <AutofillScrollManager debounceMs={180} />  {/* disable chrome autocomplete on scroll */}
      <Suspense fallback={<LoaderComponent />}>{elements}</Suspense>
    </ErrorBoundary>
  );
}

export default App;
